export const SherlockOrgTaskLabelsTypesIds = {
  EddTasksId: '66e92fef78579badecfc4202',
  SilentVerificationTasksId: '6747980de1a2c38349c74dd3',
  FraudReferralTasksId: '69ddfa710d353286afe42c37',
  AtoAutomationTasksId: '6a953a1fe5535f40406ab295'
};
